import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';
import '../App.css'; // Import the shared CSS

const BoardCell = ({ num, isPlayerPosition }) => {
    let className = 'student-board-cell'; // Renamed class
    if (isPlayerPosition) {
        className += ' player-position';
    }
    return (
        <div className={className}>
            <span>{num}</span>
        </div>
    );
};

export default function StatusBoard() {
    const [board, setBoard] = useState([]);
    const [bookCount, setBookCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const generateBoard = () => {
            const newBoard = [];
            for (let i = 0; i < 10; i++) {
                const row = [];
                for (let j = 0; j < 10; j++) {
                    const num = (i % 2 === 0)
                        ? 100 - (i * 10) - j
                        : (9 - i) * 10 + j + 1;
                    row.push(num);
                }
                newBoard.push(row);
            }
            setBoard(newBoard);
        };

        const fetchStatus = async () => {
            try {
                const { data } = await api.get('/student/status/');
                setBookCount(data.book_count);
            } catch (err) {
                setError('현황을 불러오는 데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        generateBoard();
        fetchStatus();
    }, []);

    if (loading) return <Layout><p>로딩 중...</p></Layout>;
    if (error) return <Layout><p className="message error">{error}</p></Layout>;

    return (
        <Layout>
            <Link to="/main" className="back-link">메인으로</Link>
            <div style={{ textAlign: 'center' }}>
                <h1>독서 현황판</h1>
                <p>총 {bookCount}권을 읽었습니다!</p>
            </div>
            <div className="board-wrapper">
                <div className="student-board-container"> {/* Renamed class */}
                    {board.flat().map((num) => (
                        <BoardCell key={num} num={num} isPlayerPosition={num === bookCount} />
                    ))}
                </div>
            </div>
            
        </Layout>
    );
}

